var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineRecoveryConvert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69 19.25C6 19.25 4.75 18 4.75 15.31v-2.73C4.75 9.9 6 8.65 8.69 8.65h2.73c2.68 0 3.94 1.25 3.94 3.94v2.73c-.01 2.68-1.26 3.93-3.94 3.93H8.69zm-2.44-6.66v2.73c0 1.87.57 2.44 2.44 2.44h2.73c1.87 0 2.44-.57 2.44-2.44v-2.73c0-1.87-.57-2.44-2.44-2.44H8.69c-1.87 0-2.44.57-2.44 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 15.35c-.41 0-.75-.34-.75-.75v-2.02c0-1.87-.57-2.44-2.44-2.44H9.4c-.41 0-.75-.34-.75-.75v-.7c0-2.68 1.25-3.94 3.94-3.94h2.73c2.68 0 3.94 1.25 3.94 3.94v2.73c-.01 2.68-1.26 3.93-3.95 3.93h-.71zm-3.18-6.7c2.68 0 3.94 1.25 3.94 3.94v1.27c1.84-.01 2.4-.58 2.4-2.44V8.69c0-1.87-.57-2.44-2.44-2.44h-2.73c-1.86 0-2.43.56-2.44 2.4h1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 22.37a.764.764 0 0 1 .01-.76l1.05-1.75c.21-.36.67-.47 1.03-.26.36.21.47.67.26 1.03l-.27.45c2.76-.65 4.83-3.13 4.83-6.09 0-.41.34-.75.75-.75s.75.34.75.75c-.01 4.28-3.49 7.76-7.76 7.76-.27 0-.52-.15-.65-.38zM1.25 9c0-4.27 3.48-7.75 7.75-7.75a.752.752 0 0 1 .64 1.14L8.59 4.14c-.21.35-.67.47-1.03.25a.746.746 0 0 1-.25-1.03l.27-.45A6.261 6.261 0 0 0 2.75 9c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRecoveryConvert);
export default __webpack_public_path__ + "static/media/vuesax-outline-recovery-convert.fd49dac4995ae86004b773d0733d8353.svg";
export { ForwardRef as ReactComponent };